import React, { useContext, useEffect, useState } from "react";
import Fieldset from "../../components/fieldset/Fieldset";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";
import { ReportFranchiseeContext } from "../../context/ReportFranchiseeContext";
import api from "../../services/api";
import ExportExcel from "./ExportExcel";
import { UserContext } from "../../context/UserContext";
import { GlobalVariables } from "../../global";

const FilterReportFranchisee = () => {
  const {
    cnpj,
    setCnpj,
    reason,
    setReason,
    family,
    setFamily,
    product,
    setProduct,
    version,
    setVersion,
    status,
    setStatus,
    segment,
    setSegment,
    franchisee,
    setFranchisee,
    optionsStatus,
    setOptionsStatus,
  } = useContext(ReportFranchiseeContext);
  const { user } = useContext(UserContext);
  const [optionsFamilies, setOptionsFamilies] = useState([]);
  const [optionsProducts, setOptionsProducts] = useState([]);
  const [optionsVersions, setOptionsVersions] = useState([]);
  const [optionsFranchisees, setOptionsFranchisees] = useState([]);
  const [optionsSegments, setOptionsSegments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDataFilters = async () => {
      try {
        setLoading(true);
        const { data } = await api.get("/produto/familia/versao");

        if (data.success) {
          setOptionsFamilies(data.data.families);

          setOptionsProducts(data.data.products);

          setOptionsVersions(data.data.versions);
        }

        const { data: status } = await api.get("/motivoCancelamento/todos");

        if (status.success) {
          status.data.unshift({ Id: null, Descricao: "Ativo" });
          setOptionsStatus(status.data);
        }

        if (user.IdTipoUsuario === GlobalVariables.ADM_QYON) {
          const { data: franchisees } = await api.get(
            `/promotor/todos/${GlobalVariables.TIPO_PROMOTOR_FRANQUIA}`
          );

          if (franchisees.success) {
            setOptionsFranchisees(franchisees.data);
          }
        }

        const { data: segments } = await api.get("/segmento/todos");

        if (segments.success) {
          setOptionsSegments(segments.data);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getDataFilters();
  }, [user, setOptionsStatus]);

  useEffect(() => {
    setProduct(null);
    setVersion(null);
  }, [family, setProduct, setVersion]);

  useEffect(() => {
    setVersion(null);
  }, [product, setVersion]);

  const inputsFilter = [];
  inputsFilter.push(
    {
      component: (
        <TextFieldCustom
          mask="cnpj"
          key="cnpj"
          label="CNPJ"
          lg={3}
          value={cnpj}
          setValue={setCnpj}
        ></TextFieldCustom>
      ),
    },
    {
      component: (
        <TextFieldCustom
          key="razao"
          label="Razão"
          lg={4}
          value={reason}
          setValue={setReason}
        ></TextFieldCustom>
      ),
    },
    {
      component: (
        <SelectCustom
          loading={loading}
          label="Família"
          keyObject="Descricao"
          lg={2}
          value={family}
          setValue={setFamily}
          key="select-family"
          optionsList={optionsFamilies}
        ></SelectCustom>
      ),
    },
    {
      component: (
        <SelectCustom
          disabled={family === null}
          loading={loading}
          label="Produto"
          keyObject="Descricao"
          lg={2}
          value={product}
          setValue={setProduct}
          key="select-product"
          optionsList={optionsProducts.filter(
            prod => prod.IdFamilia === (family ? family.Id : 0)
          )}
        ></SelectCustom>
      ),
    },
    {
      component: (
        <SelectCustom
          disabled={product === null}
          loading={loading}
          label="Versão"
          keyObject="Descricao"
          lg={2}
          value={version}
          setValue={setVersion}
          key="select-version"
          optionsList={optionsVersions.filter(
            vers => vers.IdProduto === (product ? product.Id : 0)
          )}
        ></SelectCustom>
      ),
    },
    {
      component: (
        <SelectCustom
          loading={loading}
          label="Status"
          keyObject="Descricao"
          lg={2}
          value={status}
          setValue={setStatus}
          key="select-status"
          optionsList={optionsStatus}
        ></SelectCustom>
      ),
    }
  );

  if (user.IdTipoUsuario === GlobalVariables.ADM_QYON) {
    inputsFilter.push({
      component: (
        <SelectCustom
          loading={loading}
          label="Franquia"
          keyObject="Razao"
          lg={2}
          value={franchisee}
          setValue={setFranchisee}
          key="select-status"
          optionsList={optionsFranchisees}
        ></SelectCustom>
      ),
    });
  }

  inputsFilter.push({
    component: (
      <SelectCustom
        loading={loading}
        label="Segmento"
        keyObject="Descricao"
        lg={3}
        value={segment}
        setValue={setSegment}
        key="select-segment"
        optionsList={optionsSegments}
      ></SelectCustom>
    ),
  });

  inputsFilter.push({
    component: <ExportExcel lg={2} />,
  });

  return (
    <div style={{ marginBottom: 20 }}>
      <Fieldset inputs={inputsFilter} key="filter" />
    </div>
  );
};

export default FilterReportFranchisee;
